// extracted by mini-css-extract-plugin
module.exports = {"impersonator-banner":"wGfRWJCMN3CEBD7NJI-dc","impersonator-banner-icon":"_1u7JeLPZsr5Z-TfKUczsIC"};